import React, { useEffect } from 'react';
import './new.css';
import { Link } from 'react-router-dom';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';

export const International = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NavBar />
      <div className='tax-page'>
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">International Business Tax Forms</h1>
            <Link to="/services" className="tax-notification-body">
              ← Back to Services
            </Link>
          </div>
        </div>

        <div className='tax-content-container'>
          <h1 className='tax-section-title'>
            Comprehensive International Business Tax Forms and Services at Easy Tax Experts.
          </h1>
          <p className='tax-section-description'>
            In today’s global economy, businesses frequently operate across borders, making compliance with international tax regulations more critical than ever. Whether you are a U.S. company expanding overseas, a foreign business entering the U.S. market, or an entrepreneur with global operations, Easy Tax Experts. ensures that your international tax obligations are handled with accuracy, efficiency, and strategic foresight.
          </p>

          <h2 className='tax-subheading'>Why Choose Easy Tax Experts. for International Tax Compliance?</h2>
          <ul className='tax-section-description'>
            <li><strong>Specialized Knowledge:</strong> Our team has extensive expertise in U.S. international tax law, IRS requirements, and bilateral tax treaties.</li>
            <li><strong>Tailored Solutions:</strong> Every business is unique. We customize our services based on your structure, industry, and international exposure.</li>
            <li><strong>Risk Mitigation:</strong> Avoid costly errors, double taxation, or penalties through our proactive compliance monitoring.</li>
            <li><strong>End-to-End Support:</strong> From tax planning to filing and audit defense, we cover the full spectrum of international tax services.</li>
          </ul>

          <h2 className='tax-subheading'>Key International Business Tax Forms We Handle</h2>
          <p className='tax-section-description'>
            Easy Tax Experts. assists with the preparation and filing of critical international tax forms, including:
          </p>
          <ol className='tax-section-description'>
            <li><strong>Form 1120-F:</strong> U.S. Income Tax Return of a Foreign Corporation.</li>
            <li><strong>Form 5471:</strong> Information Return for U.S. Persons with respect to Certain Foreign Corporations.</li>
            <li><strong>Form 5472:</strong> Return for 25% Foreign-Owned U.S. Corporations or Foreign Corporations Engaged in U.S. Business.</li>
            <li><strong>Form 8865:</strong> Return of U.S. Persons with Interests in Foreign Partnerships.</li>
            <li><strong>Form 926:</strong> Reporting Transfers of Property to Foreign Corporations.</li>
            <li><strong>Form 1042 & 1042-S:</strong> Annual Withholding Tax Return and Income Reporting for Foreign Persons.</li>
            <li><strong>Form 8938:</strong> Statement of Specified Foreign Financial Assets (FATCA compliance).</li>
            <li><strong>Form BE-10/BE-11:</strong> Surveys of U.S. Direct Investment Abroad (Bureau of Economic Analysis filings).</li>
          </ol>

          <h2 className='tax-subheading'>Our International Tax Services</h2>
          <p className='tax-section-description'>
            Beyond form preparation, we provide strategic and operational support for businesses with cross-border exposure:
          </p>
          <ul className='tax-section-description'>
            <li><strong>International Tax Planning:</strong> Structuring global operations to reduce tax burdens while ensuring compliance.</li>
            <li><strong>Cross-Border Compliance:</strong> Filing obligations in the U.S. and foreign jurisdictions with full accuracy.</li>
            <li><strong>Transfer Pricing Advisory:</strong> Guidance on related-party transactions and documentation requirements.</li>
            <li><strong>Double Taxation Relief:</strong> Applying treaty benefits to avoid paying tax in multiple countries.</li>
            <li><strong>Audit Representation:</strong> Expert support during IRS or foreign tax audits.</li>
            <li><strong>Digital Reporting & e-Filing:</strong> Assistance with electronic filings and data submission to tax authorities worldwide.</li>
          </ul>

          <h2 className='tax-subheading'>Challenges We Help You Overcome</h2>
          <ul className='tax-section-description'>
            <li>Understanding complex IRS reporting requirements for foreign investments.</li>
            <li>Staying compliant with FATCA and FBAR filing obligations.</li>
            <li>Managing transfer pricing documentation for cross-border operations.</li>
            <li>Dealing with varying tax rules in multiple jurisdictions.</li>
          </ul>

          <h2 className='tax-subheading'>Get Started Today</h2>
          <p className='tax-section-description'>
            Navigating international tax laws is complex, but with Easy Tax Experts., you don’t have to do it alone. Our team of CPAs and EAs provides expert guidance, compliance support, and strategic planning for businesses operating across borders. Contact us today to schedule a consultation and discover how we can simplify your international tax compliance.
          </p>
        </div>
      </div>

      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default International;
